export { default } from './DiabeticMonitoring';
